var makeString = require('./helper/makeString');

module.exports = function strLeftBack(str, sep) {
  str = makeString(str);
  sep = makeString(sep);
  var pos = str.lastIndexOf(sep);
  return~ pos ? str.slice(0, pos) : str;
};



//////////////////
// WEBPACK FOOTER
// ../~/underscore.string/strLeftBack.js
// module id = 459
// module chunks = 0